import { render, staticRenderFns } from "./items-in-start.vue?vue&type=template&id=416a2417"
import script from "./items-in-start.vue?vue&type=script&lang=js"
export * from "./items-in-start.vue?vue&type=script&lang=js"
import style0 from "./items-in-start.vue?vue&type=style&index=0&id=416a2417&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports